'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    accordionHeaderClassNames: function() {
        return accordionHeaderClassNames;
    },
    useAccordionHeaderStyles_unstable: function() {
        return useAccordionHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const accordionHeaderClassNames = {
    root: 'fui-AccordionHeader',
    button: 'fui-AccordionHeader__button',
    expandIcon: 'fui-AccordionHeader__expandIcon',
    icon: 'fui-AccordionHeader__icon'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    resetButton: {
        B7ck84d: "f1e4lqlz",
        De3pzq: "f1u2r49w",
        sj55zd: "f1ym3bx4",
        Bahqtrf: "f1mo0ibp",
        Be2twd7: "fjoy568",
        Bg96gwp: "fytdu2e",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1mk8lai",
        Bv0vk6g: "f37px4s",
        fsow6f: "fgusgyc"
    },
    focusIndicator: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bqhya38: "f1j6vpng",
        Bwxa6fj: [
            "f1pniga2",
            "f1ffjurs"
        ],
        Bdhvstf: "f987i1v",
        B7zbvrb: [
            "f1ffjurs",
            "f1pniga2"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        f6g5ot: 0,
        Boxcth7: 0,
        Bhdgwq3: 0,
        hgwjuy: 0,
        Bshpdp8: 0,
        Bsom6fd: 0,
        Blkhhs4: 0,
        Bonggc9: 0,
        Ddfuxk: 0,
        i03rao: 0,
        kclons: 0,
        clg4pj: 0,
        Bpqj9nj: 0,
        B6dhp37: 0,
        Bf4ptjt: 0,
        Bqtpl0w: 0,
        i4rwgc: "ffwy5si",
        Dah5zi: 0,
        B1tsrr9: 0,
        qqdqy8: 0,
        Bkh64rk: 0,
        e3fwne: "f3znvyf",
        J0r882: "f57olzd",
        Bule8hv: [
            "f4stah7",
            "fs1por5"
        ],
        Bjwuhne: "f480a47",
        Ghsupd: [
            "fs1por5",
            "f4stah7"
        ]
    },
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "f1c21dwh",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1s184ao",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5"
    },
    rootDisabled: {
        Bcmaq0h: "fwrgwhw",
        sj55zd: "f1s2aq7o"
    },
    rootInline: {
        mc9l5x: "f14t3ns0"
    },
    button: {
        qhf8xq: "f10pi13n",
        a9b677: "fly5x3f",
        B4j52fo: "fre7gi1",
        Bekrc4i: [
            "f1358rze",
            "f1rvrf73"
        ],
        Bn0qgzm: "fqdk4by",
        ibv6hh: [
            "f1rvrf73",
            "f1358rze"
        ],
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f1rmphuq",
            "f26yw9j"
        ],
        sshi5w: "f5pgtk9",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Bceei9c: "f1k6fduh",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B7ck84d: "f1ewtqcl"
    },
    buttonSmall: {
        sshi5w: "f1nxs5xn",
        Be2twd7: "fy9rknc"
    },
    buttonLarge: {
        Bg96gwp: "faaz57k",
        Be2twd7: "fod5ikn"
    },
    buttonExtraLarge: {
        Bg96gwp: "f106mvju",
        Be2twd7: "f1pp30po"
    },
    buttonInline: {
        mc9l5x: "ftuwxu6"
    },
    buttonExpandIconEndNoIcon: {
        uwmqm3: [
            "f1uw59to",
            "fw5db7e"
        ]
    },
    buttonExpandIconEnd: {
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ]
    },
    buttonDisabled: {
        Bceei9c: "fdrzuqr"
    },
    expandIcon: {
        Bqenvij: "f1l02sjl",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Bg96gwp: "f106mvju",
        Be2twd7: "f1pp30po"
    },
    expandIconStart: {
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ]
    },
    expandIconEnd: {
        Bh6795r: "fqerorx",
        Bnnss6s: "f1neuvcm",
        xawz: "flqd7gy",
        mc9l5x: "f22iagw",
        Brf1p80: "f9c4gz4",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ]
    },
    icon: {
        Bqenvij: "f1l02sjl",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Bg96gwp: "f106mvju",
        Be2twd7: "f1pp30po"
    }
}, {
    d: [
        ".f1e4lqlz{box-sizing:content-box;}",
        ".f1u2r49w{background-color:inherit;}",
        ".f1ym3bx4{color:inherit;}",
        ".f1mo0ibp{font-family:inherit;}",
        ".fjoy568{font-size:inherit;}",
        ".fytdu2e{line-height:normal;}",
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        [
            ".f1mk8lai{padding:0;}",
            {
                p: -1
            }
        ],
        ".f37px4s{-webkit-appearance:button;}",
        ".fgusgyc{text-align:unset;}",
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        [
            ".ffwy5si[data-fui-focus-visible]::after{border:2px solid var(--colorStrokeFocus2);}",
            {
                p: -2
            }
        ],
        [
            ".f3znvyf[data-fui-focus-visible]::after{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}",
        ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}",
        ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}",
        ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        [
            ".f1s184ao{margin:0;}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fwrgwhw{background-image:none;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f14t3ns0{display:inline-block;}",
        ".f10pi13n{position:relative;}",
        ".fly5x3f{width:100%;}",
        ".fre7gi1{border-top-width:0;}",
        ".f1358rze{border-right-width:0;}",
        ".f1rvrf73{border-left-width:0;}",
        ".fqdk4by{border-bottom-width:0;}",
        [
            ".f1rmphuq{padding:0 var(--spacingHorizontalM) 0 var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f26yw9j{padding:0 var(--spacingHorizontalMNudge) 0 var(--spacingHorizontalM);}",
            {
                p: -1
            }
        ],
        ".f5pgtk9{min-height:44px;}",
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}",
        ".f1k6fduh{cursor:pointer;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1nxs5xn{min-height:32px;}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".ftuwxu6{display:inline-flex;}",
        ".f1uw59to{padding-left:var(--spacingHorizontalM);}",
        ".fw5db7e{padding-right:var(--spacingHorizontalM);}",
        ".f11gcy0p{padding-right:var(--spacingHorizontalMNudge);}",
        ".f1ng84yb{padding-left:var(--spacingHorizontalMNudge);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1l02sjl{height:100%;}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".fqerorx{flex-grow:1;}",
        ".f1neuvcm{flex-shrink:1;}",
        ".flqd7gy{flex-basis:0%;}",
        ".f9c4gz4{justify-content:flex-end;}"
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1j6vpng[data-fui-focus-visible]::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ffjurs[data-fui-focus-visible]::after{border-left-color:Highlight;}.f1pniga2[data-fui-focus-visible]::after{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f987i1v[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useAccordionHeaderStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(accordionHeaderClassNames.root, styles.root, state.inline && styles.rootInline, state.disabled && styles.rootDisabled, state.root.className);
    state.button.className = (0, _react.mergeClasses)(accordionHeaderClassNames.button, styles.resetButton, styles.button, styles.focusIndicator, state.expandIconPosition === 'end' && !state.icon && styles.buttonExpandIconEndNoIcon, state.expandIconPosition === 'end' && styles.buttonExpandIconEnd, state.inline && styles.buttonInline, state.size === 'small' && styles.buttonSmall, state.size === 'large' && styles.buttonLarge, state.size === 'extra-large' && styles.buttonExtraLarge, state.disabled && styles.buttonDisabled, state.button.className);
    if (state.expandIcon) {
        state.expandIcon.className = (0, _react.mergeClasses)(accordionHeaderClassNames.expandIcon, styles.expandIcon, state.expandIconPosition === 'start' && styles.expandIconStart, state.expandIconPosition === 'end' && styles.expandIconEnd, state.expandIcon.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(accordionHeaderClassNames.icon, styles.icon, state.icon.className);
    }
    return state;
};
